import React from 'react';
import {GlossaryDispatch} from '../../Glossary';
import {ChevronIcon} from '../ChevronIcon';
import style from './style.module.scss';

export function MobileIndexBlock() {
  const {toggleIndexCollapse} = React.useContext(GlossaryDispatch);

  const onIndexClick = () => {
    toggleIndexCollapse();
  };

  return (
    <div
      className={style.mobileIndexBlock}
      onClick={onIndexClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onIndexClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Toggle index"
    >
      <ChevronIcon className={style.mobileIndexBlock_icon} />
      index
    </div>
  );
}
